/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Outlook_SearchInputs */

const es_tools_outlook_search = /** @type {(inputs: Tools_Outlook_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando en Outlook...`)
};

const en_tools_outlook_search = /** @type {(inputs: Tools_Outlook_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching Outlook...`)
};

/**
* | output |
* | --- |
* | "Searching Outlook..." |
*
* @param {Tools_Outlook_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_outlook_search = /** @type {((inputs?: Tools_Outlook_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Outlook_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_outlook_search(inputs)
	return en_tools_outlook_search(inputs)
});
export { tools_outlook_search as "tools.outlook.search" }